module.exports = function getResource(label) {
    const resources = {
        selectAShade: 'Choisissez une teinte',
        next: 'Suivant'
    };
    return resources[label];
};
